export const slotMapping = {
  "08-12": 8,
  "12-16": 12,
  "16-20": 16,
};
